import { CLEAR_NETWORK_GROUPS } from 'actions';

export default function clearNetworkGroups() {
  return (dispatch) => dispatch({ type: CLEAR_NETWORK_GROUPS });
}
